import { QueueItem, ExtendedBasket, BasketQueue } from "./config";

export {
  basket_selector,
  basket_queue_selector,
  basket_id_selector,
  basket_get_item_in_queue,
};

function basket_selector(state): ExtendedBasket | null {
  return state.basket.data;
}

function basket_id_selector(state) {
  return state.basket.data && state.basket.data.id;
}

function basket_queue_selector(state): BasketQueue {
  return state.basket.queue;
}

function basket_get_item_in_queue(state, product_id): undefined | QueueItem {
  let item = state.basket.queue.items[product_id];
  return item || undefined;
}
